import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { toast } from 'react-toastify';

const initialState = {
    loading: false,
    error: null,
}

export const sendNewEmailByPo = createAsyncThunk(
    'mail/sendNewEmailByPo',
    async ({ 
      id,
      type
    }, { rejectWithValue }) => {
      try {
        const { data } = await axios.post(`/api/v1/email/send-email-by-po`, { id, type });
        return data;
      } catch (error) {
        if ('string' === typeof error.response.data) {
          return rejectWithValue({ error: error.response.data })
        } else {
          return rejectWithValue({ error: error.response.data.errors || error.response.data.error })
        }
      }
    }
)

export const mailSlice = createSlice({
    name: 'mail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(sendNewEmailByPo.pending, (state) => {
            state.loading = true
        })
        .addCase(sendNewEmailByPo.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
            toast.success(`Mail sent successfully.`, { position: "bottom-right" })
        })
        .addCase(sendNewEmailByPo.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            toast.error(
              `Mail can't be sent. Error - ${action.error?.message}.`, { position: "bottom-right" }
            )
        })
    }
})

export const {} = mailSlice.actions;

export default mailSlice.reducer